module.exports = __webpack_public_path__ + "static/media/sign-up.443b5464.svg";